<div id="create-new-proposal" class="new-proposal revealed">
  <h2 i18n="@@proposals.create_new_proposal">Create New Proposal</h2>
  <div class="new-proposal__content">
    <form class="new-proposal__form" action="" method="get">
      <ul class="new-proposal__navigation">
        <li (click)="goToStep('client-detail')" [class.active]="activeStep.key == 'client-detail'" i18n="@@proposals.client_details">Client Details</li>
        <li (click)="selectedClient && goToStep('project-detail')" [class.active]="activeStep.key == 'project-detail'" i18n="@@proposals.project_details">Project Details</li>
        <li (click)="selectedClient && goToStep('quotes')" [class.active]="activeStep.key == 'quotes'" i18n="@@proposals.quote">Quote</li>
        <li (click)="selectedClient && goToStep('terms')" [class.active]="activeStep.key == 'terms'" i18n="@@proposals.terms">Terms & Conditions</li>
      </ul>
      
      <proposal-client-detail 
        [hidden]="activeStep.key !== 'client-detail'"
        (onComplete)="onCompleteStep($event)"
        #clientDetailRef>
      </proposal-client-detail>

      <proposal-project-detail
        [hidden]="activeStep.key !== 'project-detail'"
        (onComplete)="onCompleteStep($event)"
        (triggerPrevious)="previousStep()">
      </proposal-project-detail>

      <proposal-quotes 
        [proposalNumber]="proposalNumber"
        [defaultPaymentInfo]="defaultPaymentInfo"
        [client]="selectedClient"
        [hidden]="activeStep.key !== 'quotes'"
        (onComplete)="onCompleteStep($event)"
        (triggerPrevious)="previousStep()"
        (skipStep)="skipStep()">
      </proposal-quotes>

      <proposal-terms 
        [hidden]="activeStep.key !== 'terms'"
        [defaultTerms]="defaultTerms"
        (onComplete)="onCompleteStep($event)"
        (triggerPrevious)="previousStep()"
        (skipStep)="skipStep()">
      </proposal-terms>

      <proposal-overview 
        *ngIf="activeStep.key === 'overview'"
        [proposalNumber]="proposalNumber"
        (triggerPrevious)="previousStep()"
        [stepDetails]="steps"
        (saveProposal)="saveProposal($event)">
      </proposal-overview>
    </form>
  </div>
  <!--end create-new-proposal-content  -->
</div>
<!-- end create-new-proposal-wrapper -->